module.exports = __webpack_public_path__ + "img/logo.cb60e0ac.jpg";